import { n as e, r as t, t as n } from "./service.types-B-7T0reA.js";
import { useWebSocket as r } from "@vueuse/core";
//#region ../../node_modules/.pnpm/es-toolkit@1.51.0/node_modules/es-toolkit/dist/util/attempt.mjs
function i(e) {
	try {
		return [null, e()];
	} catch (e) {
		return [e, null];
	}
}
//#endregion
//#region src/composables/useEventService.ts
var a = {}, o = /* @__PURE__ */ new Set([
	"ping",
	"pong",
	"/ping",
	"/pong"
]), s = (e, t) => `wss://${e === n.Event ? "event" : `event.${String(e).toLowerCase()}`}.${t === "acceptance" ? "api.acceptance" : "api"}.myparcel.nl`, c = (e) => {
	if (!e.accessToken) throw Error("No accessToken provided.");
	let t = new URLSearchParams();
	t.append("accessToken", e.accessToken), "shopIds" in e && e.shopIds.forEach((e) => {
		t.append("shopIds", e);
	});
	let n = t.toString();
	if (!a[e.serviceName] || a[e.serviceName].filter !== n) {
		let c = s(e.serviceName, e.environment), l = {}, u = /* @__PURE__ */ new Set(), d = (t) => {
			if (typeof t == "string" && o.has(t)) {
				console.info(`[WebSocket][${e.serviceName}] Heartbeat: ${t}`);
				return;
			}
			if (typeof t == "string" && /^[{[]/.test(t.trim())) {
				let [n, r] = i(() => JSON.parse(t));
				n ? console.warn(`[WebSocket][${e.serviceName}] Failed to parse JSON message:`, t, n) : console.info(`[WebSocket][${e.serviceName}] Message:`, r);
				return;
			}
			console.info(`[WebSocket][${e.serviceName}] Message (text):`, t);
		};
		e.autoReconnect !== !1 && (l.autoReconnect = {
			retries: 10,
			delay: 3e3
		}), e.heartBeat !== !1 && (l.heartbeat = {
			message: "/ping",
			interval: 1e4,
			pongTimeout: 5e3
		}), l.onMessage = (t, n) => {
			let r = n.data;
			e.withLogging && d(r), !(typeof r != "string" || o.has(r)) && u.forEach((t) => {
				let [n] = i(() => t(r));
				n && e.withLogging && console.error(`[WebSocket][${e.serviceName}] Message subscriber threw:`, n);
			});
		}, e.withLogging && (l.onConnected = () => console.info(`[WebSocket][${e.serviceName}] Connected`), l.onDisconnected = (t, n) => {
			console.info(`[WebSocket][${e.serviceName}] Disconnected.`, {
				reason: n.reason,
				event: n
			});
		}, l.onError = (t, n) => console.info(`[WebSocket][${e.serviceName}] Error: `, n), typeof l.autoReconnect == "object" && (l.autoReconnect.onFailed = () => console.info(`[WebSocket][${e.serviceName}] Reconnection failed.`)));
		let { send: f, status: p, close: m } = r(`${c}?${t.toString()}`, l), h = {
			status: p,
			send: f,
			close: m,
			onMessage: (e) => (u.add(e), () => u.delete(e))
		};
		a[e.serviceName] && a[e.serviceName].connection.close(), a[e.serviceName] = {
			connection: h,
			filter: n
		};
	}
	return a[e.serviceName].connection;
}, l = (t, n) => {
	let r = t.message ?? t.event;
	if (r) switch (r.case) {
		case e.SalesChannelStatusChanged: n.onSalesChannelStatusChanged?.(r.value);
	}
};
//#endregion
export { e as EventCaseName, n as EventService, t as EventSocketMessageAggregateType, l as matchEventServiceEvent, c as useEventService };
